//React
import React from 'react';

//Resource

//interfaces

//Pages
import { SitesManagement } from 'pages/sites';

//Store
import { useUserSiteManagementData } from './useUserSiteManagementData';

export const UserSiteManagement: React.FC = () => {
  const {
    sites,
    payors,
    organizations,
    isLoading,
    isError,
    isFetching,
    errorMessage,
  } = useUserSiteManagementData();

  return (
    <SitesManagement
      sites={sites}
      payors={payors}
      organizations={organizations}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
